import { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./style.css";

class SimpleSlider extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 1200,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      fade: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            autoplaySpeed: 3000,
          },
        },
      ],
    };
    return (
      <Slider {...settings}>
        <div id="home" className="item1">
          <div className="container">
            <div className="slide-content">
              <div className="slide-subtitle">
                <h4>Our Journey & Ever After</h4>
              </div>
              <div className="slide-title">
                <h2>Huy Hanh & Linh Phương</h2>
              </div>
              <div className="slide-text">
                <p>Kỷ niệm ngày chung đôi • 26.02.2026</p>
              </div>
            </div>
          </div>
        </div>

        <div className="item2">
          <div className="container">
            <div className="slide-content">
              <div className="slide-subtitle">
                <h4>Chào mừng bạn ghé thăm</h4>
              </div>
              <div className="slide-title">
                <h2>Nhật Ký Hôn Nhân & Những Chuyến Đi</h2>
              </div>
              <div className="slide-text">
                <p>Nơi lưu giữ từng bước chân và nụ cười thanh xuân</p>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    );
  }
}

export default SimpleSlider;
